module.exports = __webpack_public_path__ + "static/img/IMG_20160821_140237.61fbfdd3.jpg";